import styled from 'styled-components';

export const ButtonAction = styled.div`
  align-items: center;
  background-color: #a761a9;
  border: 2px solid #a761a9;
  border-radius: 8px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 35px;
  justify-content: center;
  transition: all 0.3s;
  width: 260px;

  &:hover {
    background-color: #fff;
    color: #a761a9;
    cursor: pointer;
    transition: all 0.3s;
  }
`;
